module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-banner', {
    attrs: {
      "image": 'src/assets/images/' + _vm.image
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.home.about.title')))]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.home.about.content'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.home.clients.title')))]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.home.clients.content'))
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "row wrap mt-2"
  }, _vm._l((_vm.clients), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "route-card pa-3",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('router-link', {
      staticClass: "route-card-link",
      attrs: {
        "to": item.route
      }
    }, [_c('v-card', {
      attrs: {
        "hover": ""
      }
    }, [_c('v-card-title', {
      class: 'white--text blue darken-' + (index + 1),
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "headline"
    }, [_vm._v(_vm._s(_vm.$t('pages.home.clients.elements.' + item.name + '.name')))])])]), _vm._v(" "), _c('v-card-media', {
      staticClass: "white--text",
      attrs: {
        "height": "200px",
        "src": 'src/assets/images/' + item.image
      }
    }), _vm._v(" "), _c('v-card-text', [_vm._v("\n                        " + _vm._s(_vm.$t('pages.home.clients.elements.' + item.name + '.content')) + "\n                    ")])], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-239ba2ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 433
// module chunks = 0